module.exports = __webpack_public_path__ + "img/vipprivileges_zh.4fcd1352.png";